import React from 'react'
import css from './styles.scss'
import { Link } from 'react-router-dom'

const NotFound = () => (
  <div className={css.container}>
    <div className={css.attention}>!</div>
    <h4 className={css.h2}>Page Not Found</h4>
    <p>
      The page you are requesting could not be found.
    </p>
    <p>
      <Link to='/'>Return to home page</Link>
    </p>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// /app/js/components/NotFound/index.js